import React from "react";
import { ReactComponent as Icon } from "./brightness_3-white-18dp.svg";

const MoonIcon = () => {
  return (
    <>
      <Icon style={{ width: "36px", height: "36px" }} />
    </>
  );
};

export default MoonIcon;
